module.exports = __webpack_public_path__ + "img/oo_logo.55e8caef.png";